<template>
  <div class="app-main-content programManagement">
    <div class="main-content">
      <div>
        <!-- <el-button type="primary" @click="query">查询</el-button> -->
        <!-- <el-button @click="reset">重置</el-button> -->
        <el-button type="primary" @click="add">新增</el-button>
      </div>
      <!-- <div class="section" style="background-color:#fff;margin-top:6px;">
        <el-form :inline="true" :model="form" label-width="80px">
          <el-form-item label="计划名称">
            <el-input v-model="form.planName" placeholder="请输入计划名称" style="width:300px;" />
          </el-form-item>
          <el-form-item label="机器人名称">
            <el-input v-model="form.robotName" placeholder="请输入机器人名称" style="width:300px;" />
          </el-form-item>
          <el-form-item label="创建时间">
            <el-date-picker v-model="form.startTime" type="date" placeholder="开始时间" />
            <span style="margin:0 10px;">-</span>
            <el-date-picker v-model="form.endTime" type="date" placeholder="截止时间" />
          </el-form-item>
        </el-form>
      </div> -->
      <div class="section" style="background-color:#fff;margin-top:6px;">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column label="序号" prop="sorting" width="50" />
          <el-table-column label="计划名称" prop="scheduleName" />
          <el-table-column label="机器人名称" prop="taskName" />
          <el-table-column label="创建时间" prop="dateCreated" />
          <el-table-column label="计划开始日期" prop="taskDailyStart" />
          <el-table-column label="计划结束日期" prop="taskDailyEnd" />
          <el-table-column label="计划状态">
            <template slot-scope="scope">
              <span :class="{'setColorOrange':scope.row.taskState === 0, 'setColorBlue':scope.row.taskState === 1,'setColorGray':scope.row.taskState === 2,}">{{ taskState(scope.row.taskState) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="启动/停止" prop="startOrStop">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.taskRunningState"
                :active-value="1"
                :inactive-value="0"
                active-color="#409eff"
                inactive-color="#97a8be"
                @change="start(scope.row)"
              />
            </template>
          </el-table-column>

          <el-table-column fixed="right" label="操作" width="300">
            <template slot-scope="scope">
              <el-button type="text" size="small" :class="[scope.row.taskRunningState === 1?'banClick':'']" @click="editor(scope.row)">编辑</el-button>
              <el-button type="text" size="small" @click="details(scope.row)">详情</el-button>
              <el-button type="text" size="small" style="color:red;" @click="deletes(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <plan-dialog
      ref="planDialog"
      :dialog-form="dialogForm"
      :robot-list="robotList"
      @planCancel="planCancel"
      @nextStep="nextStep"
    />
    <configuration-dialog
      ref="configurationDialog"
      :configuration-form="configurationForm"
      @configurationCancel="configurationCancel"
      @lastStep="lastStep"
      @createPlan="createPlan"
    />
  </div>
</template>
<script>
import planDialog from './components/planDialog'
import configurationDialog from './components/configurationDialog'
import { getList, addOrUpdateRobot } from '@/api/robot/programManagement'
import { taskConfigs } from '@/api/robot/operationRobot'
import { getLoading } from '@/utils/utilBaseElement'
export default {
  name: 'ProgramManagement',
  components: { planDialog, configurationDialog },
  data() {
    return {
      dialogForm: {
        show: false,
        editor: true
      },
      configurationForm: {
        show: false,
        buttonShow: false,
        editor: true
      },
      loading: false,
      taskScheduleUuid: '',
      robotList: [],
      tableData: [],
      form: {}
    }
  },
  created() {
    this.getListFunc()
    this.taskConfigsList()
  },
  methods: {
    // 获取列表
    async getListFunc() {
      this.loading = getLoading()
      const data = {}
      const res = await getList(data).finally(() => {
        this.loading.close()
      })
      if (res.ok) {
        if (res.data.length !== 0) {
          res.data.forEach((item, index) => {
            if (item.taskDailyStart) {
              item.taskDailyStart = item.taskDailyStart.substring(0, 10)
            }
            if (item.taskDailyEnd) {
              item.taskDailyEnd = item.taskDailyEnd.substring(0, 10)
            }
            item.sorting = index + 1
          })
        }
        this.tableData = res.data
      } else {
        this.tableData = []
      }
    },
    // 新增-创建计划
    async createPlan(form) {
      if (this.taskScheduleUuid) {
        this.planRequest(2, form)
      } else {
        this.planRequest(1, form)
      }
    },
    async planRequest(type, form) {
      // 新增
      let data = {}
      // 新增时请求方式为post,编辑、删除、启动停止时为put
      let request = 'put'
      if (type === 1 || type === 2) {
        if (type === 1) {
          request = 'post'
        }
        if (type === 2) {
          this.robotList.map((item) => {
            if (item.taskName === this.form.robotName) {
              this.form.robotName = item.uuid
            }
          })
        }
        data = {
          taskScheduleUuid: this.taskScheduleUuid,
          taskConfigUuid: this.form.robotName,
          scheduleName: this.form.planName,
          dataInfo: form.dataInfo,
          taskRunningPlan: this.form.frequency,
          notifyEmail: form.email
        }
        if (this.form.frequency === 0) {
          let dateTime = ''
          if (type === 1) {
            dateTime = `${this.form.selectDate} ${this.form.elapsedTime}`
          } else {
            const time = this.form.selectDate.slice(0, 10)
            dateTime = `${time} ${this.form.elapsedTime}`
          }
          dateTime = new Date(dateTime).valueOf()
          data.taskRunDateTimeLong = dateTime
        } else {
          const startTime = new Date(this.form.selectDateArr[0]).valueOf()
          const endTime = new Date(this.form.selectDateArr[1]).valueOf()
          data.taskDailyStartLong = startTime // 每天开始日期
          data.taskDailyEndLong = endTime // 每天结束日期
          data.taskDailyTimeString = this.form.elapsedTime // 每天运行时间
          if (this.form.elapsedTime.length === 5) {
            data.taskDailyTimeString = `${this.form.elapsedTime}:00`
          }
        }
      }
      // 启动/停止
      if (type === 3) {
        data = {
          taskScheduleUuid: form.taskScheduleUuid,
          taskState: form.taskState
        }
      }
      // 删除
      if (type === 4) {
        data = {
          taskScheduleUuid: form.taskScheduleUuid,
          taskState: -1
        }
      }
      this.loading = getLoading()
      const res = await addOrUpdateRobot(data, request).finally(() => {
        this.loading.close()
      })
      if (res.ok) {
        switch (type) {
          case 1:
            this.$refs.configurationDialog.reset()
            this.$refs.planDialog.reset()
            this.$message.success('添加成功')
            this.configurationCancel()
            break
          case 2:
            this.$refs.configurationDialog.reset()
            this.$message.success('更新成功')
            this.configurationCancel()
            break
          case 3:
            if (form.taskState === 0) {
              this.$message.success('已终止')
            }
            if (form.taskState === 1) {
              this.$message.success('已启动')
            }
            break
          case 4:
            this.$message.success('删除成功')
            break
        }
        this.getListFunc()
      }
    },
    // 删除
    deletes(row) {
      this.$confirm('计划任务删除后无法恢复，确认删除？', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.planRequest(4, row)
      })
    },
    // 获取系统机器人列表
    async taskConfigsList() {
      const res = await taskConfigs()
      if (res.ok) {
        this.robotList = res.data
        this.checkList = [res.data[0].taskName]
      } else {
        this.robotList = []
      }
    },
    // 编辑
    editor(row) {
      this.taskScheduleUuid = row.taskScheduleUuid
      // taskRunningState===1为启动，不可点击编辑
      if (row.taskRunningState === 1) {
        return
      }
      this.dialogForm = {
        show: true,
        editor: true
      }
      this.$refs.planDialog.onShow(row)
      this.$refs.configurationDialog.params(row)
      this.configurationForm.editor = true
    },
    // 详情
    details(row) {
      this.$refs.planDialog.onShow(row)
      this.$refs.configurationDialog.params(row)
      this.dialogForm = {
        show: true,
        editor: false
      }
      this.configurationForm.editor = false
    },
    // 新增
    add() {
      this.taskScheduleUuid = ''
      this.dialogForm = {
        show: true,
        editor: true
      }
      this.configurationForm.editor = true
    },
    // 启动/停止
    start(row) {
      if (!row.taskRunningState) {
        this.$confirm('确认立即停止该计划？', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const data = {
            taskState: 0,
            taskScheduleUuid: row.taskScheduleUuid
          }
          this.planRequest(3, data)
        }).catch(() => {
          row.taskRunningState = 1
        })
      } else {
        this.$confirm('确认立即启动该计划？', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const data = {
            taskState: 1,
            taskScheduleUuid: row.taskScheduleUuid
          }
          this.planRequest(3, data)
        }).catch(() => {
          row.taskRunningState = 0
        })
      }
    },
    // 新增弹窗关闭
    planCancel() {
      this.dialogForm.show = false
      this.$refs.planDialog.reset()
      this.$refs.configurationDialog.reset()
    },
    // 新增下一步弹窗打开
    nextStep(form) {
      this.form = form
      this.robotList.map((item) => {
        if (item.taskName === this.form.robotName) {
          this.form.robotName = item.uuid
        }
      })
      this.$refs.configurationDialog.addParams(this.form)
      this.configurationForm.show = true
      this.configurationForm.buttonShow = true
    },
    // 新增第二步弹窗关闭
    configurationCancel() {
      this.lastStep()
      this.planCancel()
    },
    // 关闭配置弹窗
    lastStep() {
      this.configurationForm.show = false
    },
    // 转换机器人状态值
    taskState(taskState) {
      switch (taskState) {
        case 0:
          return '待运行'
        case 1:
          return '已运行'
        case 2:
          return '手动终止'
      }
    }
  }
}
</script>
<style lang="scss">
.programManagement{
  .setColorOrange{
    color:orange;
  }
  .setColorBlue{
    color:#1F75D5;
  }
  .setColorGray{
    color:#97a8be;
  }
  .banClick{
    opacity: 0.5;
  }
}

</style>
